export const config = {
  AboutIntro: {
    title: 'About you',
    description: 'Tell us a little bit about yourself so your Beauty Therapist can prepare for your appointment.',
  },
};
